import { safeAllocate } from '../core';
import type { AllocateParams } from '../core';

/**
 * Distribute the amount of a Dinero object across a list of ratios.
 *
 * @param dineroObject - The Dinero object to allocate from.
 * @param ratios - The ratios to allocate the amount to.
 *
 * @returns A new Dinero object.
 *
 * @public
 */
export function allocate<TAmount, TCurrency extends string>(
  ...[dineroObject, ratios]: AllocateParams<TAmount, TCurrency>
) {
  const { calculator } = dineroObject;
  const allocateFn = safeAllocate(calculator);

  return allocateFn(dineroObject, ratios);
}
